/* GG Hobby — LIVE NOW banner
   Polls window.GG_LIVE_API (the Worker /api/live feed, pushed by the GG Hobby program when a
   show starts). While anyone is live, the #tonight band flips to LIVE NOW: who's on, which
   channel, what's on the show, and a direct link to the right stream. When nobody's live it
   returns to the default "What's on live tonight" copy. Honest by design: the banner only says
   LIVE when the program says so — never faked. */
(function () {
  "use strict";

  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }

  var api = window.GG_LIVE_API || (window.GG_PRICE_API ? window.GG_PRICE_API.replace(/\/prices\b.*/, "/live") : "");
  var section = document.getElementById("tonight");
  if (!api || !section) return;
  var band = section.querySelector(".tonight__band") || section;  // the styled band gets .is-live

  var eyebrow = document.getElementById("tonightEyebrow");
  var title = document.getElementById("tonightTitle");
  var desc = document.getElementById("tonightDesc");
  var cta = document.getElementById("tonightCta");
  if (!eyebrow || !title || !desc || !cta) return;

  // remember the default (not-live) state so we can restore it
  var def = {
    eyebrow: eyebrow.innerHTML,
    title: title.innerHTML,
    desc: desc.textContent,
    ctaText: cta.textContent,
    ctaHref: cta.getAttribute("href"),
    ctaClass: cta.className,
    ctaDisabled: cta.getAttribute("aria-disabled"),
  };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function sinceLabel(iso) {
    var t = Date.parse(iso || "");
    if (isNaN(t)) return "";
    var mins = Math.max(1, Math.round((Date.now() - t) / 60000));
    if (mins < 60) return tr("live for {n} min").replace("{n}", mins);
    var h = Math.floor(mins / 60), m = mins % 60;
    return m
      ? tr("live for {h}h {m}m").replace("{h}", h).replace("{m}", m)
      : tr("live for {h}h").replace("{h}", h);
  }

  function removeMulti() {
    var grid = document.getElementById("liveMulti");
    if (grid) grid.remove();
  }

  // 2+ concurrent shows: every stream gets its own card — who, what's on the table, watch link
  function renderMulti(sessions) {
    var grid = document.getElementById("liveMulti");
    if (!grid) {
      grid = document.createElement("div");
      grid.id = "liveMulti";
      grid.className = "live-multi";
      band.appendChild(grid);
    }
    grid.innerHTML = "";
    sessions.slice(0, 6).forEach(function (s) {
      var card = document.createElement("div");
      card.className = "live-multi__card";
      var who = document.createElement("span");
      who.className = "live-multi__who";
      who.innerHTML = '<span class="live-dot"></span> ';
      who.appendChild(document.createTextNode(s.streamer || "GG Hobby"));
      var ch = document.createElement("span");
      ch.className = "live-multi__ch";
      ch.textContent = (s.channel || tr("live")) + " · " + sinceLabel(s.startedAt);
      card.appendChild(who); card.appendChild(ch);
      var items = (s.items || []).slice(0, 4);
      if (items.length) {
        var it = document.createElement("span");
        it.className = "live-multi__items";
        it.textContent = items.join(" · ") + ((s.items || []).length > 4 ? tr(" + more") : "");
        card.appendChild(it);
      }
      if (s.url) {
        var a = document.createElement("a");
        a.className = "btn btn--primary btn--sm";
        a.href = s.url;
        a.target = "_blank";
        a.rel = "noopener";
        a.textContent = tr("Watch {who} →").replace("{who}", s.streamer || tr("live"));
        card.appendChild(a);
      }
      grid.appendChild(card);
    });
  }

  function goLive(sessions) {
    var multi = sessions.length > 1;
    var s = sessions[0];
    if (multi) {
      eyebrow.innerHTML = '<span class="live-dot"></span> ' + tr("LIVE RIGHT NOW · {n} CHANNELS").replace("{n}", sessions.length);
      title.innerHTML = tr('{n} shows are <span class="grad">live right now.</span>').replace("{n}", sessions.length);
      desc.innerHTML = tr("Pick a stream and jump in — every show below is ripping.") + ' &nbsp;·&nbsp; <a href="https://discord.gg/d6Q737ENWT" target="_blank" rel="noopener" style="color:var(--cyan);border-bottom:1px solid rgba(25,200,255,.35)">' + tr("Live pings in the Discord →") + "</a>";
      cta.style.display = "none";
      renderMulti(sessions);
    } else {
      cta.style.display = "";
      removeMulti();
      eyebrow.innerHTML = '<span class="live-dot"></span> ' + tr("LIVE RIGHT NOW");
      title.innerHTML = (s.streamer
        ? tr('{who} is live on <span class="grad">{channel}.</span>').replace("{who}", esc(s.streamer))
        : tr('We are live on <span class="grad">{channel}.</span>')
      ).replace("{channel}", esc(s.channel || tr("stream")));
      var items = (s.items || []).slice(0, 6);
      var text = items.length
        ? tr("On the show right now: {items}").replace("{items}", items.join(" · ") + (s.items.length > 6 ? tr(" + more") : "")) + ". " + sinceLabel(s.startedAt)
        : tr("We're ripping live right now — jump in.") + " " + sinceLabel(s.startedAt);
      desc.innerHTML = esc(text) + ' &nbsp;·&nbsp; <a href="https://discord.gg/d6Q737ENWT" target="_blank" rel="noopener" style="color:var(--cyan);border-bottom:1px solid rgba(25,200,255,.35)">' + tr("Live pings in the Discord →") + "</a>";
      if (s.url) {
        cta.className = "btn btn--primary";
        cta.removeAttribute("aria-disabled");
        cta.setAttribute("href", s.url);
        cta.setAttribute("target", "_blank");
        cta.setAttribute("rel", "noopener");
        cta.textContent = tr("Watch {who} live →").replace("{who}", s.streamer ? esc(s.streamer) : tr("the stream"));
      }
    }
    band.classList.add("is-live");
  }

  function goDefault() {
    removeMulti();
    cta.style.display = "";
    eyebrow.innerHTML = def.eyebrow;
    title.innerHTML = def.title;
    desc.textContent = def.desc;
    cta.textContent = def.ctaText;
    cta.className = def.ctaClass;
    if (def.ctaHref) cta.setAttribute("href", def.ctaHref); else cta.removeAttribute("href");
    if (def.ctaDisabled) cta.setAttribute("aria-disabled", def.ctaDisabled);
    cta.removeAttribute("target");
    band.classList.remove("is-live");
  }

  function poll() {
    fetch(api, { cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var sessions = (data && data.sessions) || [];
        if (sessions.length) goLive(sessions); else goDefault();
      })
      .catch(function () { /* keep whatever state we had */ });
  }

  poll();
  setInterval(poll, 60000);
})();
